import React, { Component } from 'react'

import KatalogNg from '../block/KatalogNg'
import KatalogTop from '../block/KatalogTop'
import About from '../block/About'
import Faq from '../block/Faq'
import TextPage from '../block/TextPageNobc'

class App extends Component {

  render() {

    const data = this.props?.data || {}
    // На посадочных (подмена страницы каталога) тематические товары уже выведены
    // в TextPageNobc из восьмой колонки таблицы — общий блок товаров там только дублирует контент.
    const hasOwnProducts = data?.podmena == 1 && (data?.podmena_products || []).length > 0

    return (
      <>
        {data?.podmena == 1 && <TextPage data={data} />}
        <KatalogNg data={data} offset={2} hone={data?.podmena != 1 ? true : false} />
        {!hasOwnProducts && <KatalogTop data={data} />}
        <About data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App